import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { scheduleIntervalListSelector } from '../_selectors/scheduleIntervalList.selector';
import { ScheduleIntervalAction } from '../scheduleInterval.action';
import { ScheduleIntervalTranslator } from '../scheduleInterval.translator';

type IState =
  & IGetSelectorStateType<typeof scheduleIntervalListSelector>;

type IDependencies = IClientApiDependencySegment;

export const updateIntervalEpic: IEpic<IState, IDependencies> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(ScheduleIntervalAction.update.started),
  withLatestFrom(state$),
  mergeMap(([{ params, resolve, reject }, state]) => {
    const { scheduleId, index, interval } = params;

    const intervals = scheduleIntervalListSelector(state, { scheduleId }).map(ScheduleIntervalTranslator.toApi);
    const newInterval = ScheduleIntervalTranslator.formToApi(interval);
    if (index === undefined) {
      intervals.push(newInterval);
    } else {
      intervals.splice(index, 1, newInterval);
    }

    return dependencies.api.updateScheduleIntervalList({ scheduleId, intervals }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          ScheduleIntervalAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ScheduleIntervalAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
